/**
 * @desc: 固件升级 UI
 */
import Emitter from '../../emitter';
let onOKH = () => { };
let onFailH = () => { };
export const UIFirmware = {
    id: 'system.ui.firmware.uploader',
    open(firmwareInfo) {
        Emitter.emit('ShowUpdateFirmware', firmwareInfo);
    },
    onOK(handler) {
        onOKH = (data) => {
            try {
                handler(data);
            }
            catch (ex) {
                console.error(ex);
            }
        };
    },
    onFail(handler) {
        onFailH = (err) => {
            try {
                handler(err);
            }
            catch (ex) {
                console.error(ex);
            }
        };
    }
};
UIFirmware.open = UIFirmware.open.bind(UIFirmware);
UIFirmware.onOK = UIFirmware.onOK.bind(UIFirmware);
UIFirmware.onFail = UIFirmware.onFail.bind(UIFirmware);
Emitter.on('downloadFirmwareOK', (data) => onOKH(data));
Emitter.on('downloadFirmwareFail', (err) => onFailH(err));
